module.exports = __webpack_public_path__ + "media/images/badges/clubpilates/milestone-1-Active-ClubPilates-14be0ccdc4173fd4755c6eb7ab7876f8.png";